import React, { FC } from "react";
import { Button } from "@primer/react";
import { GridRow } from "@getregistered/greg-editors";

export interface PrintButtonPrimerProps {
  selectedItems?: GridRow[];
  remainingItemsCount: number;
  batchSize: number;
  onClick: () => void;
}

export const PrintButtonPrimer: FC<PrintButtonPrimerProps> = ({
  remainingItemsCount,
  selectedItems,
  batchSize,
  onClick,
}) => {
  if (selectedItems !== undefined && selectedItems.length > 0) {
    return (
      <Button 
        onClick={onClick} 
        variant="primary"
        size="medium"
      >
        Print {selectedItems.length} Selected
      </Button>
    );
  }

  if (remainingItemsCount === 0) {
    return (
      <Button 
        variant="primary"
        size="medium"
        disabled
      >
        Select Items to Print
      </Button>
    );
  }

  return (
    <Button 
      onClick={onClick} 
      variant="primary"
      size="medium"
    >
      Print {remainingItemsCount <= batchSize ? "Remaining" : "Next"}{" "}
      {Math.min(remainingItemsCount, batchSize)}
    </Button>
  );
}; 